
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { useFamilyForm } from "./FamilyFormContext";
import { PlusCircle, Trash2 } from "lucide-react";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

export function GrandparentsSection() {
  const { grandparents, addGrandparent, updateGrandparent, removeGrandparent } = useFamilyForm();
  const { language } = useLanguage();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label className="text-base">{t('family.grandparents', language)}</Label>
        <Button 
          type="button" 
          variant="ghost" 
          size="sm" 
          onClick={addGrandparent}
          className="flex items-center text-primary"
        >
          <PlusCircle className="h-4 w-4 mr-1" />
          {language === 'ja' ? '祖父母を追加' : 'Add Grandparent'}
        </Button>
      </div>
      
      {grandparents.length === 0 && (
        <p className="text-sm text-muted-foreground italic text-center py-2">
          {language === 'ja' ? 'まだ祖父母が追加されていません' : 'No grandparents added yet'}
        </p>
      )}
      
      {grandparents.map((grandparent) => (
        <div key={grandparent.id} className="space-y-3 p-3 border rounded-md relative">
          <div className="space-y-2">
            <Label htmlFor={`grandparent-name-${grandparent.id}`}>
              {language === 'ja' ? '名前' : 'Name'}
            </Label>
            <Input
              id={`grandparent-name-${grandparent.id}`}
              value={grandparent.name}
              onChange={(e) => updateGrandparent(grandparent.id, "name", e.target.value)}
              placeholder={language === 'ja' ? '祖父母の名前を入力' : "Enter grandparent's name"}
            />
          </div>
          
          <div className="space-y-2">
            <Label>{t('family.grandparentRelation', language)}</Label>
            <RadioGroup 
              value={grandparent.relation} 
              onValueChange={(value) => updateGrandparent(grandparent.id, "relation", value)}
              className="flex space-x-4"
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="maternal" id={`maternal-${grandparent.id}`} />
                <Label htmlFor={`maternal-${grandparent.id}`} className="cursor-pointer">
                  {t('family.maternal', language)}
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="paternal" id={`paternal-${grandparent.id}`} />
                <Label htmlFor={`paternal-${grandparent.id}`} className="cursor-pointer">
                  {t('family.paternal', language)}
                </Label>
              </div>
            </RadioGroup>
          </div>
          
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={() => removeGrandparent(grandparent.id)}
            className="absolute top-2 right-2 h-7 w-7 text-destructive"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      ))}
    </div>
  );
}
